module.exports = __webpack_public_path__ + "afafe98ec9a898a14cbb54513f25f58c.pdf";